export default __webpack_public_path__ + "static/media/Cal_Icon.ee52781f.svg";